var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import moment from "moment";
import { useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getAttendee, getGroup, getOrder } from "../../data/api";
import Constants from "../../data/constants";
import { log, Style } from "../../data/helpers";
import useWidgetHistory from "../../hooks/useWidgetHistory";
import { WidgetActions } from "../../interfaces/WidgetParams";
import { setGlobalLoaders } from "../../store/AppState/actions";
import { WidgetContext } from "../Widget";
var LoaderPage = function () {
    var history = useWidgetHistory();
    var _a = useContext(WidgetContext), combinedWidgetConfig = _a.combinedWidgetConfig, setGASessions = _a.setGASessions;
    var dispatch = useDispatch();
    var search = useLocation().search;
    var gaSessionsRaw = new URLSearchParams(search).get("gaSessions");
    var getAction = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var newParams, attendee, newParams, order, newParams, group, newParams, newParams, newParams;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    if (!(params.action === WidgetActions.smart)) return [3 /*break*/, 9];
                    if (!params.path) return [3 /*break*/, 1];
                    newParams = {
                        action: WidgetActions.url,
                        path: params.path,
                    };
                    return [2 /*return*/, newParams];
                case 1:
                    if (!params.attendeeId) return [3 /*break*/, 3];
                    return [4 /*yield*/, getAttendee(params.attendeeId)];
                case 2:
                    attendee = _o.sent();
                    if (attendee) {
                        newParams = {
                            action: WidgetActions.attendees,
                            attendeeId: params.attendeeId,
                            clientKey: (_a = params.clientKey) !== null && _a !== void 0 ? _a : "-",
                            urlKey: (_b = params.urlKey) !== null && _b !== void 0 ? _b : "-",
                            eventNumber: (_c = attendee.data.eventNumber.toString()) !== null && _c !== void 0 ? _c : "",
                            attendeeAction: params.attendeeAction,
                        };
                        return [2 /*return*/, newParams];
                    }
                    return [3 /*break*/, 8];
                case 3:
                    if (!params.orderId) return [3 /*break*/, 5];
                    return [4 /*yield*/, getOrder(params.orderId)];
                case 4:
                    order = _o.sent();
                    if (order) {
                        newParams = {
                            action: WidgetActions.orders,
                            orderId: params.orderId,
                            clientKey: (_d = params.clientKey) !== null && _d !== void 0 ? _d : "-",
                            urlKey: (_e = params.urlKey) !== null && _e !== void 0 ? _e : "-",
                            eventNumber: (_f = order.data.eventNumber.toString()) !== null && _f !== void 0 ? _f : "",
                        };
                        return [2 /*return*/, newParams];
                    }
                    return [3 /*break*/, 8];
                case 5:
                    if (!params.groupId) return [3 /*break*/, 7];
                    return [4 /*yield*/, getGroup(params.groupId)];
                case 6:
                    group = _o.sent();
                    if (group) {
                        newParams = {
                            action: WidgetActions.group,
                            groupId: params.groupId,
                            clientKey: (_g = params.clientKey) !== null && _g !== void 0 ? _g : "-",
                            urlKey: (_h = params.urlKey) !== null && _h !== void 0 ? _h : "-",
                            eventNumber: (_j = group.data.eventNumber.toString()) !== null && _j !== void 0 ? _j : "",
                        };
                        return [2 /*return*/, newParams];
                    }
                    return [3 /*break*/, 8];
                case 7:
                    if (params.eventNumber) {
                        newParams = {
                            action: WidgetActions.register,
                            clientKey: (_k = params.clientKey) !== null && _k !== void 0 ? _k : "-",
                            urlKey: (_l = params.urlKey) !== null && _l !== void 0 ? _l : "-",
                            eventNumber: (_m = params.eventNumber) !== null && _m !== void 0 ? _m : "",
                            promo: params.promo,
                            access: params.access,
                            preview: params.preview,
                            typeCode: params.typeCode,
                            group: params.group,
                            all: params.all,
                            type: params.type,
                            typeQty: params.typeQty,
                            start: params.start,
                        };
                        return [2 /*return*/, newParams];
                    }
                    else if (params.clientKey) {
                        newParams = {
                            action: WidgetActions.list,
                            clientKey: params.clientKey,
                            urlKey: params.urlKey,
                            view: params.view,
                            startsAt: params.startsAt,
                            endsAt: params.endsAt,
                            search: params.search,
                        };
                        return [2 /*return*/, newParams];
                    }
                    _o.label = 8;
                case 8: return [2 /*return*/, params];
                case 9: return [2 /*return*/, params];
            }
        });
    }); };
    var getSrc = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var combinedWidgetConfig, newSrc, promo, access, preview, typeCode, group, type, typeQty, all, obj_1, paramArray_1, newSrc, newSrc, search_1, startsAt, endsAt, view, obj_2, paramArray_2, newSrc, newSrc, newSrc, newSrc, newSrc, newSrc;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getAction(params)];
                case 1:
                    combinedWidgetConfig = _c.sent();
                    if (combinedWidgetConfig.debugMode) {
                        console.log("Assessed WidgetConfig", combinedWidgetConfig);
                    }
                    switch (combinedWidgetConfig.action) {
                        case WidgetActions.register:
                            if (combinedWidgetConfig.eventNumber) {
                                newSrc = Constants.Routes.eventStart
                                    .replace(":clientKey", (_a = combinedWidgetConfig.clientKey) !== null && _a !== void 0 ? _a : "-")
                                    .replace(":urlKey", (_b = combinedWidgetConfig.urlKey) !== null && _b !== void 0 ? _b : "-")
                                    .replace(":eventNumber", combinedWidgetConfig.eventNumber);
                                if (combinedWidgetConfig.start) {
                                    newSrc = "".concat(newSrc, "/").concat(combinedWidgetConfig.start);
                                }
                                if (combinedWidgetConfig.promo ||
                                    combinedWidgetConfig.access ||
                                    combinedWidgetConfig.preview ||
                                    combinedWidgetConfig.typeCode ||
                                    combinedWidgetConfig.group ||
                                    combinedWidgetConfig.type ||
                                    combinedWidgetConfig.typeQty) {
                                    promo = combinedWidgetConfig.promo, access = combinedWidgetConfig.access, preview = combinedWidgetConfig.preview, typeCode = combinedWidgetConfig.typeCode, group = combinedWidgetConfig.group, type = combinedWidgetConfig.type, typeQty = combinedWidgetConfig.typeQty, all = combinedWidgetConfig.all;
                                    obj_1 = {
                                        promo: promo,
                                        access: access,
                                        preview: preview,
                                        typeCode: typeCode,
                                        group: group,
                                        type: type,
                                        typeQty: typeQty,
                                        all: all,
                                    };
                                    paramArray_1 = [];
                                    Object.keys(obj_1).forEach(function (key) {
                                        if (obj_1[key] !== undefined && obj_1[key] !== null) {
                                            paramArray_1.push("".concat(key, "=").concat(obj_1[key]));
                                        }
                                    });
                                    newSrc = "".concat(newSrc, "?").concat(paramArray_1.join("&"));
                                }
                                return [2 /*return*/, newSrc];
                            }
                            else {
                                log("Details buttons must include 'clientKey', 'urlKey', and 'eventNumber' parameters", Style.error);
                            }
                            break;
                        case WidgetActions.detail:
                            if (combinedWidgetConfig.clientKey && combinedWidgetConfig.urlKey && combinedWidgetConfig.eventNumber) {
                                newSrc = Constants.Routes.details
                                    .replace(":clientKey", combinedWidgetConfig.clientKey)
                                    .replace(":urlKey", combinedWidgetConfig.urlKey)
                                    .replace(":eventNumber", combinedWidgetConfig.eventNumber);
                                return [2 /*return*/, newSrc];
                            }
                            else {
                                log("Details buttons must include 'clientKey', 'urlKey', and 'eventNumber' parameters", Style.error);
                            }
                            break;
                        case WidgetActions.list:
                            if (combinedWidgetConfig.clientKey) {
                                newSrc = Constants.Routes.eventList
                                    .replace(":clientKey", combinedWidgetConfig.clientKey)
                                    .replace("/:urlKey?", combinedWidgetConfig.urlKey ? "/".concat(combinedWidgetConfig.urlKey) : "");
                                if (combinedWidgetConfig.search ||
                                    combinedWidgetConfig.startsAt ||
                                    combinedWidgetConfig.endsAt ||
                                    combinedWidgetConfig.view) {
                                    search_1 = combinedWidgetConfig.search, startsAt = combinedWidgetConfig.startsAt, endsAt = combinedWidgetConfig.endsAt, view = combinedWidgetConfig.view;
                                    obj_2 = {
                                        search: search_1,
                                        startsAt: startsAt,
                                        endsAt: endsAt,
                                        view: view,
                                    };
                                    paramArray_2 = [];
                                    Object.keys(obj_2).forEach(function (key) {
                                        if (obj_2[key] !== undefined && obj_2[key] !== null) {
                                            paramArray_2.push("".concat(key, "=").concat(obj_2[key]));
                                        }
                                    });
                                    newSrc = "".concat(newSrc, "?").concat(paramArray_2.join("&"));
                                }
                                return [2 /*return*/, newSrc];
                            }
                            else {
                                log("List buttons must include 'clientKey'", Style.error);
                            }
                            break;
                        case WidgetActions.calendar:
                            if (combinedWidgetConfig.clientKey) {
                                newSrc = Constants.Routes.calendar
                                    .replace(":clientKey", combinedWidgetConfig.clientKey)
                                    .replace("/:urlKey?", combinedWidgetConfig.urlKey ? "/".concat(combinedWidgetConfig.urlKey) : "")
                                    .replace(":date?", moment().format("YYYY-MM-DD")) // set it today's date
                                    .replace("/:eventNumber?", "")
                                    .replace("/:sharedCapacityId?", "");
                                return [2 /*return*/, newSrc];
                            }
                            else {
                                log("Calendar buttons must include 'clientKey'", Style.error);
                            }
                            break;
                        case WidgetActions.lookup:
                            if (combinedWidgetConfig.clientKey && combinedWidgetConfig.urlKey && combinedWidgetConfig.eventNumber) {
                                newSrc = Constants.Routes.myDashboard
                                    .replace(":clientKey", combinedWidgetConfig.clientKey)
                                    .replace(":urlKey", combinedWidgetConfig.urlKey)
                                    .replace(":eventNumber", combinedWidgetConfig.eventNumber)
                                    .replace("/:lookupId?", combinedWidgetConfig.lookupId ? "/".concat(combinedWidgetConfig.lookupId) : "");
                                return [2 /*return*/, newSrc];
                            }
                            else {
                                newSrc = Constants.Routes.lookup.replace("/:lookupId?", combinedWidgetConfig.lookupId ? "/".concat(combinedWidgetConfig.lookupId) : "");
                                return [2 /*return*/, newSrc];
                            }
                        case WidgetActions.attendees:
                            if (combinedWidgetConfig.clientKey && combinedWidgetConfig.urlKey && combinedWidgetConfig.eventNumber) {
                                newSrc = Constants.Routes.myAttendee
                                    .replace(":clientKey", combinedWidgetConfig.clientKey)
                                    .replace(":urlKey", combinedWidgetConfig.urlKey)
                                    .replace(":eventNumber", combinedWidgetConfig.eventNumber)
                                    .replace("/:attendeeId", combinedWidgetConfig.attendeeId
                                    ? "/".concat(combinedWidgetConfig.attendeeId).concat(combinedWidgetConfig.attendeeAction
                                        ? "/".concat(combinedWidgetConfig.attendeeAction)
                                        : "")
                                    : "")
                                    .replace(Constants.Regex.guid, "");
                                return [2 /*return*/, newSrc];
                            }
                            else {
                                log("Attendees buttons must include 'clientKey', 'urlKey', and 'eventNumber' parameters", Style.error);
                            }
                            break;
                        case WidgetActions.orders:
                            if (combinedWidgetConfig.clientKey && combinedWidgetConfig.urlKey && combinedWidgetConfig.eventNumber) {
                                newSrc = Constants.Routes.myOrder
                                    .replace(":clientKey", combinedWidgetConfig.clientKey)
                                    .replace(":urlKey", combinedWidgetConfig.urlKey)
                                    .replace(":eventNumber", combinedWidgetConfig.eventNumber)
                                    .replace("/:orderId", combinedWidgetConfig.orderId ? "/".concat(combinedWidgetConfig.orderId) : "")
                                    .replace(Constants.Regex.guid, "");
                                return [2 /*return*/, newSrc];
                            }
                            else {
                                log("Order buttons must include 'clientKey', 'urlKey', and 'eventNumber' parameters", Style.error);
                            }
                            break;
                        case WidgetActions.group:
                            if (combinedWidgetConfig.clientKey && combinedWidgetConfig.urlKey && combinedWidgetConfig.eventNumber) {
                                newSrc = Constants.Routes.myGroup
                                    .replace(":clientKey", combinedWidgetConfig.clientKey)
                                    .replace(":urlKey", combinedWidgetConfig.urlKey)
                                    .replace(":eventNumber", combinedWidgetConfig.eventNumber)
                                    .replace("/:groupId", combinedWidgetConfig.groupId ? "/".concat(combinedWidgetConfig.groupId) : "")
                                    .replace(Constants.Regex.guid, "");
                                return [2 /*return*/, newSrc];
                            }
                            else {
                                log("Group buttons must include 'clientKey', 'urlKey', and 'eventNumber' parameters", Style.error);
                            }
                            break;
                        case WidgetActions.url:
                            if (combinedWidgetConfig.path) {
                                return [2 /*return*/, combinedWidgetConfig.path];
                            }
                            else {
                                log("Url buttons must include 'path'", Style.error);
                            }
                            break;
                    }
                    return [2 /*return*/, "/oops"];
            }
        });
    }); };
    useEffect(function () {
        if (gaSessionsRaw) {
            setGASessions(JSON.parse(atob(gaSessionsRaw)));
        }
        dispatch(setGlobalLoaders({ loadingPage: true }));
        return function () {
            dispatch(setGlobalLoaders({ loadingPage: false }));
        };
    }, []);
    useEffect(function () {
        if (combinedWidgetConfig) {
            getSrc(combinedWidgetConfig).then(function (src) {
                history.replace(src, src === "/oops"
                    ? { error: "The combined Brushfire properties could not be used to open a valid widget URL." }
                    : undefined);
            });
        }
    }, [combinedWidgetConfig]);
    return _jsx("div", {});
};
export default LoaderPage;
